import validatePop from "@/plugins/validatePop.js"
import Vue from "vue"
import _ from "lodash"

const vm = new Vue()

export const uploadImageDropoff = async (payload) => {
    return new Promise((resolve, reject) => {
        vm.$http.post(vm.$API_URL + "/dropoff/upload-image", 
        {
            image: payload.image,
            query_id: payload.query_id,
        },
        {
            headers: {
                "Content-Type": "application/json",
                Token: localStorage.getItem("access_token")
            },
        })
        .then((res) => {
          let checkError = validatePop(res)
          if (!checkError.status) {
            reject(checkError.msg)
          }
    
          const { data } = res.data
        
          const response = {
            query_id: _.get(data, 'query_id'),
            image_url: _.get(data, 'image_url'),
            expired_in: _.get(data, 'expired_in'),
          }

          resolve(response)
        })
      })
}